<div class="space-y-6">
  <app-page-header
    [backTo]="['/operators', op()?.id ?? '']"
    backLabel="Retour à la fiche"
    title="Modifier l'opérateur"
    subtitle="Met à jour les champs métier. Statut, taux et référence CREDIT se gèrent depuis la fiche."
  />

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      loadingMessage="Chargement…"
      (retry)="fetch()"
    />
  } @else if (op(); as o) {
    <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <app-operator-form
        mode="edit"
        [initial]="o"
        [submitting]="submitting()"
        [serverError]="serverError()"
        (saveEdit)="onSave($event)"
        (cancel)="onCancel()"
      />
    </section>
  }
</div>
